import { Link, useParams } from "react-router-dom";
import ReadingGuideArticlePage from "../components/ReadingGuideArticlePage";
import {
  READING_GUIDES,
  READING_GUIDE_ARTICLES,
} from "../data/readingGuidesContent";

const ReadingGuideArticle = () => {
  const { slug } = useParams();
  const guide = READING_GUIDES.find((g) => g.slug === slug);
  const article = READING_GUIDE_ARTICLES[slug];

  if (!guide || !article) {
    return (
      <div
        className="min-h-screen flex flex-col items-center justify-center px-6 text-center"
        style={{ background: "var(--bg)", color: "var(--text)" }}
      >
        <h1 className="font-serif text-3xl mb-4">Guide not found</h1>
        <Link
          to="/reading-guides"
          className="text-sm px-5 py-2.5 rounded-full border"
          style={{ borderColor: "var(--border)", color: "var(--brand)" }}
        >
          Back to reading guides
        </Link>
      </div>
    );
  }

  return <ReadingGuideArticlePage guide={guide} article={article} />;
};

export default ReadingGuideArticle;
